import { Component } from '@angular/core';
import { Option, StaticStringSelectComponent } from '../static-string-select/static-string-select.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

export const InvoiceStatusOptions: Option[] = [
  {
    value: 'VOID',
    label: 'AUTOMATIONS.EDITOR.FILTERS.INVOICE_DATA.DATA_LABELS.STATUS.VOID',
  },
  {
    value: 'PAID',
    label: 'AUTOMATIONS.EDITOR.FILTERS.INVOICE_DATA.DATA_LABELS.STATUS.PAID',
  },
  {
    value: 'DUE',
    label: 'AUTOMATIONS.EDITOR.FILTERS.INVOICE_DATA.DATA_LABELS.STATUS.DUE',
  },
  {
    value: 'DRAFT',
    label: 'AUTOMATIONS.EDITOR.FILTERS.INVOICE_DATA.DATA_LABELS.STATUS.DRAFT',
  },
];

@Component({
  selector: 'automata-invoice-status-options',
  templateUrl: '../static-string-select/static-string-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class InvoiceStatusOptionsComponent extends StaticStringSelectComponent {
  options: Option[] = InvoiceStatusOptions;
  label = 'AUTOMATIONS.EDITOR.FILTERS.ORDER_DATA.DATA_LABELS.STATUS';
  required = false;
}
